import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'employerSelect',
    'freeFormUnionContainer',
    'workEmailConfirmation',
    'fullFormContainer',
    'unnamedUnionContainer',
    'unionMessageContainer',
    'emailLabel',
    'emailConfirmationLabel',
    'personalEmailLabel',
    'personalEmailConfirmationLabel',
    'personalEmailHint',
  ]

  handleSelection() {
    // Hide all containers by default.
    this.fullFormContainerTarget.classList.add('d-none')
    this.unnamedUnionContainerTarget.classList.add('d-none')
    this.unionMessageContainerTarget.classList.add('d-none')

    // If they haven't selected a union, don't show anything.
    const select = this.employerSelectTarget
    const unionValue = select.options[select.selectedIndex].innerHTML
    if (unionValue === '' || unionValue === undefined) {
      return
    }

    const otherUnion = unionValue === 'Other Union';
    const noUnion = unionValue === 'No Union';

    // If they've selected "Other union", show the freeform union field.
    if (otherUnion) {
      this.freeFormUnionContainerTarget.classList.remove('d-none')
      $("#user_employer_extended_info").prop("required", true);
    }
    else {
      this.freeFormUnionContainerTarget.classList.add('d-none')
      $("#user_employer_extended_info").removeAttr("required");
    }

    // If they have selected a named union, show the full form and return.
    if (!(otherUnion || noUnion)) {
      this.fullFormContainerTarget.classList.remove('d-none')
      this.#unionLabels()
      return
    }

    // If they have not selected a named union, show the work email confirmation selection.
    this.unnamedUnionContainerTarget.classList.remove('d-none')
    this.#nonUnionLabels()

    // Only show the full form if they've selected "Yes".
    // Otherwise, show the message div.
    this.workEmailConfirmationTargets.forEach(element => {
      if (element.checked) {
        if (element.value === 'Yes') {
          this.fullFormContainerTarget.classList.remove('d-none')
        } else {
          this.unionMessageContainerTarget.classList.remove('d-none')
        }
      }
    })
  }

  initialize() {
    this.handleSelection();
  }

  #unionLabels() {
    this.#updateLabel(this.emailLabelTarget, 'The email registered with your union')
    this.#updateLabel(this.emailConfirmationLabelTarget, 'The email registered with your union confirmation')
    this.#updateLabel(this.personalEmailLabelTarget, 'Contact email')
    this.#updateLabel(this.personalEmailConfirmationLabelTarget, 'Contact email confirmation')
    this.#updateLabel(this.personalEmailHintTarget, 'Please provide an email address for tickets, booking confirmations, account updates and marketing (if applicable). To ensure that you can receive our emails, we recommend this is not your work email address. It can be the same as the email address provided above if required')
  }

  #nonUnionLabels() {
    this.#updateLabel(this.emailLabelTarget, 'Your work/registered email')
    this.#updateLabel(this.emailConfirmationLabelTarget, 'Your work/registered email confirmation')
    this.#updateLabel(this.personalEmailLabelTarget, 'Alternative contact email')
    this.#updateLabel(this.personalEmailConfirmationLabelTarget, 'Alternative contact email confirmation')
    this.#updateLabel(this.personalEmailHintTarget, 'Please provide an email address for tickets, booking confirmations, account updates and marketing (if applicable). To ensure that you can receive our emails, this must not be your work email address.')
  }

  // Labels have an <abbr> tag to indicate the field is required.
  // So we can't just alter the whole innerHTML value.
  // So use the node system instead.
  #updateLabel(labelElement, newLabelValue) {
    labelElement.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.nodeValue = newLabelValue
      }
    })
  }
}
